import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import CSSModules from 'react-css-modules';
import { Dialog, Size } from '@pegasus/ui-components/components/dialog';
import { Button, ButtonType, ButtonColor } from '@pegasus/ui-components/components/button';
import Translate from '@client/components/shared/translation/Translate';
import { NotificationPermissionIcon } from '@client/components/shared/SvgIcons';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import { track } from '@client/helpers/tracking';

import {
    getIsReenablementDialogOpen,
    getCampaignToSubscribe
} from '@client/redux/modules/pushNotification/selectors';
import { getHasAccessibleOrange } from '@client/redux/modules/abtesting/accessibleOrange/selectors';

import {
    hideReenablementDialog
} from '@client/redux/modules/pushNotification/actions';

import styles from './styles.scss';

export class NotificationReenableDialog extends Component {
    static propTypes = {
        isShown: PropTypes.bool,
        campaignToSubscribe: PropTypes.string,
        hideReenablementDialog: PropTypes.func.isRequired,
        accessibleOrange: PropTypes.bool
    }

    render() {
        const { isShown, accessibleOrange } = this.props;

        return (
            <TranslationsScope path="notificationReenableDialog">
                <Dialog isShown={isShown} size={Size.M} closeDialog={this.closeDialog}>
                    <div styleName="wrapper">
                        <div styleName="icon-container">
                            <NotificationPermissionIcon styleName="notificaiton-icon" blocked />
                        </div>
                        <div styleName="text-container">
                            <div styleName="title"><Translate message="title" /></div>
                            <div styleName="text"><Translate message="text" /></div>
                        </div>
                        <div styleName="buttons-container">
                            <div styleName="button-wrapper">
                                <Button
                                    buttonType={ButtonType.primary}
                                    color={accessibleOrange ? ButtonColor.primary : ButtonColor.brand}
                                    fullWidth
                                    onClick={this.closeDialog}
                                >
                                    <Translate message="closeButton" />
                                </Button>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </TranslationsScope>
        );
    }

    closeDialog = () => {
        const { campaignToSubscribe } = this.props;
        track('notification_push_blockedClose', { productCampaign: campaignToSubscribe });
        this.props.hideReenablementDialog();
    }
}

const mapStateToProps = state => ({
    isShown: getIsReenablementDialogOpen(state),
    campaignToSubscribe: getCampaignToSubscribe(state),
    accessibleOrange: getHasAccessibleOrange(state)
});

const mapDispatchToProps = {
    hideReenablementDialog,
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    CSSModules(styles)
)(NotificationReenableDialog);
